import { gql } from "@apollo/client";

import { EventDefinitionAttribute } from "Types/EventDefinition";

export type UpsertEventDefinitionInput = UpsertEventDefinitionInputData & {
    eventType: string;
    eventName: string;
};

export type UpsertEventDefinitionInputData = {
    showInFeed: boolean;
    displayName: string | null;
    displayColor: string | null;
    displayEmoji: string | null;
    attributes: EventDefinitionAttribute[];
    teamIds: string[];
};

export const upsertEventDefinitionMutation = gql`
    mutation UpsertEventDefinition($upsert: UpsertEventDefinitionInput!) {
        upsertEventDefinition(upsert: $upsert) {
            eventType
            eventName
            displayName
            displayEmoji
            displayColor
            showInFeed
            attributes {
                attributeKey
                displayName
            }
            updatedBy
            updatedAt
        }
    }
`;
